import { Box } from '@mui/system';
import React from 'react'

export default function Loader() {
    return (
        <Box sx={{ position: "fixed", top: "0", left: "0", backgroundColor: "#00000085", height: "100vh", width: "100%", zIndex:"9999" }}>
            <Box sx={{borderRadius: "4px", width: "fit-content", position: "fixed", left: "50%", top: "50%", transform: "translate(-50%, -50%)", zIndex: "99999" }}>
                <span className="loader"></span>
            </Box>
        </Box>
    )
}
